"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.sdk = void 0;
const axios_client_1 = require("@invivodf/axios-client");
const infrastructure_1 = require("./infrastructure");
const sdk = (apiHost, config) => {
    const client = (0, axios_client_1.createAxiosClient)(apiHost, { ...config, useHttpError: true });
    return {
        exportStocks: (0, infrastructure_1.exportStocks)(client),
        removeEmptyStocks: (0, infrastructure_1.removeEmptyStocks)(client),
        getStocks: (0, infrastructure_1.getStocks)(client),
        searchStocks: (0, infrastructure_1.searchStocks)(client),
        getRealtimeStocks: (0, infrastructure_1.getRealtimeStocks)(client),
        putStocks: (0, infrastructure_1.putStocks)(client)
    };
};
exports.sdk = sdk;
